import Component from '../Component';

const {AlignmentToolbar, BlockControls} = wp.blockEditor;

export default class AlignX extends Component {
  render() {
    if (this.isView()) return null;

    return (
      <BlockControls>
        <AlignmentToolbar
          value={this.attr()}
          onChange={val => this.setAttr(val)}
        />
      </BlockControls>
    );
  }
}
